<template>
  <div class="page-content cinema-detail">
    <el-breadcrumb separator="/" class="egl-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/cinema' }">{{ $locale("global.cinema") }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ breadcrumbTitle }}</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form class="egl-elm egl-detail" :model="form" ref="cinemaDetailForm" label-position="top">
      <div class="form-module-tit">{{ $locale('global.basicInfo') }}</div>
      <BasicSetting v-bind:regionData="region_arr" v-bind:detailObj="form"></BasicSetting>

      <hr class="dotted" />
      <div class="form-module-tit">{{ $locale('setting.cinema.online') }}</div>
      <el-row :gutter="20" v-for="(item, idx) in form.cinemaSetting.gmailList" :key="idx">
        <el-col :span="20" ><PaySetting v-bind:detailObj="form" :index="idx" :actionType="action" type="cinemaSetting" :adminType="adminType"></PaySetting></el-col>
        <el-col :span="4" :style="{ 'display':'flex'}" >
          <div class="operation" @click="minus(idx)"
          >
            <i class="el-icon-minus"></i>
          </div>
          <div class="operation" @click="plus"
          >
            <i class="el-icon-plus"></i>
          </div>
        </el-col>
      </el-row>
      <hr class="dotted" />
      <div class="form-module-tit">{{ $locale('setting.cinema.displayLoginScreen') }}</div>
      <el-row>
        <el-col :span="6">
          <el-select v-model="form.cinemaSetting.displayCLScreen">
            <el-option :label="$locale('global.yes')" :value="true"></el-option>
            <el-option :label="$locale('global.no')" :value="false"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <hr class="dotted" />
      <div class="form-module-tit">{{ $locale('setting.cinema.ticketsales') }}</div>
      <TicketSetting v-bind:detailObj="form" />

      <hr class="dotted" />
      <div class="form-module-tit">{{ $locale('setting.cinema.trailer') }}</div>
      <TrailSetting v-bind:detailObj="form" ref="trailerset" />

      <template v-if="adminType === 'brand' || adminType === 'cinema'">
        <hr class="dotted" />
        <div class="form-module-tit">{{ $locale('setting.cinema.admission') }}</div>
        <EntranceSetting v-bind:detailObj="form"></EntranceSetting>
      </template>

      <hr class="dotted" />
      <div class="form-module-tit">{{ $locale('setting.cinema.jointSetting') }}</div>
      <JointSetting v-bind:detailObj="form"></JointSetting>

      <hr class="dotted" />
      <div class="form-module-tit">{{ $locale('setting.cinema.linkage') }}</div>
      <SystemSetting v-bind:detailObj="form" v-bind:serial="serialNum"></SystemSetting>

      <template v-if="action !== 'create'">
        <hr class="dotted" />
        <div class="form-module-tit">{{ $locale('setting.cinema.openAPIjointInfo') }}</div>
        <OpenApiJointInfo :detailObj="form"></OpenApiJointInfo>
      </template>

      <template v-if="action === 'create'">
        <hr class="dotted" />
        <div class="form-module-tit">{{ $locale('setting.cinema.accounts') }}</div>
        <AccountSetting v-bind:detailObj="form"></AccountSetting>
      </template>

      <hr class="dotted" v-if=" adminType === 'brand' " />
      <div class="form-module-tit" v-if=" adminType === 'brand' ">{{ $locale('user.roleAuthorization') }}</div>
      <el-form-item :label="$locale('user.roleAuthorization')" class="role-form-item" v-if=" adminType === 'brand' " prop="roleId" :rules="roleIdRules">
        <el-button
          v-for="role in allRoles"
          :class="form.roleId == role.id ? 'egl-btn-white' : 'egl-btn-white-gray-border'"
          @click="chooseRole(role.id)"
          :key="role.id"
        >{{ role.name }}</el-button>
      </el-form-item>
    </el-form>

    <div class="detail-page-btn" v-if="action != 'detail'">
      <el-button class="egl-btn-white" @click="cancel_fn">{{ $locale("global.cancel") }}</el-button>
      <el-button class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm") }}</el-button>
    </div>
  </div>
</template>

<script>
import BasicSetting from "@/components/Cinema/BasicSetting";
import PaySetting from  "@/components/Cinema/PaySetting";
import TicketSetting from "@/components/Cinema/TicketSetting";
import EntranceSetting from "@/components/Cinema/EntranceSetting";
import SystemSetting from "@/components/Cinema/SystemSetting";
import AccountSetting from "@/components/Cinema/AccountSetting";
import JointSetting from "@/components/Cinema/JointSetting";
import TrailSetting from "@/components/Cinema/TrailSetting";
import OpenApiJointInfo from "@/components/Cinema/OpenApiJointInfo";
import { getRegions, getRoleList } from "@/helpers/service/api/common.js";
import {
  createCinema, getCinemaDetail, updateCinema, getCinemaCode, getBrandDetail
} from "@/helpers/service/api/cinema.js";
import { requestAll } from "@/helpers/service/axiosPlugin";
import countDownAlert from "@/utils/countDownAlert";
import { localStorage } from "@/utils/localStorage";
import "@/assets/style/cinema.less";

export default {
  name: "cinemaDetail",
  components: {
    BasicSetting,
    PaySetting,
    TicketSetting,
    EntranceSetting,
    SystemSetting,
    AccountSetting,
    JointSetting,
    TrailSetting,
    OpenApiJointInfo,
  },
  data() {
    return {
      editable: true,
      action: "create",
      breadcrumbTitle: this.$locale("setting.cinema.new"),
      form: this.createFormObj_fn(),
      region_arr: [],
      serialNum: "001",
      allRoles: [],
      adminType: window.localStorage.getItem("adminType"),
      roleIdRules: [ {
        required: true,
        message: this.$locale("user.plsSelectRoleAuthorization"),
      } ],
    };
  },
  methods: {
    createFormObj_fn() {
      return {
        brandId: localStorage.get("brandId"),
        roleId: "",
        cinemaSetting: {
          displayCLScreen: true,
          dailyCloseTime: 24,
          scanStartMin: 0,
          scanEndMin: 0,
          gmoShopId: "",
          gmoShopPass: "",
          gmailUserName: "",
          gmailApiKey: "",
          freeSeat: false,
          websiteCode: "",
          releaseAfterMin: 0,
          releaseBeforeMin: 0,
          seatMaxPos: 0,
          seatMaxWeb: 0,
          showDaysPos: 0,
          showDaysWeb: 0,
          reprintCountCC: 0,
          reprintCountPOS: 0,
          reprintInvoiceCountPOS: 0,
          reprintReceiptCountPOS: 0,
          gmailList: [
            {
              gmailUserName: "",
              gmailApiKey: "",
              refreshToken: "",
              accessToken: ""
            }
          ],
          scanEndType: "startTime",
          scanOrder: "admission",
        },
        address: "",
        address1: "",
        address2: "",
        approve: true,
        businessHours: "",
        businessStatus: "",
        brandCode: "",
        cinemaCode: "",
        cinemaCodeEgl: "",
        cinemaSignageKey: "",
        cinemaWebKey: "",
        city: "",
        cityId: "",
        closeTime: "",
        controllerUrl: "",
        copyright: "",
        edit: null,
        email: "",
        endorse: false,
        facebookUrl: "",
        faxNumber: "",
        hot: 0,
        id: "",
        instagramUrl: "",
        intro: "",
        journalCinema1: "",
        journalCinema2: "",
        journalCinema3: "",
        logo: "",
        managerName: "",
        name: "",
        oldCinemaUuid: "",
        openTime: 0,
        phone: "",
        photosUrl: [],
        postalCode: "",
        prefecture: "",
        region: "",
        remittingParty1: "",
        remittingParty2: "",
        remittingParty3: "",
        service: {},
        status: "",
        stills: [ "" ],
        tags: [],
        tmsCinemaServer: "",
        twitterUrl: "",
        versionId: "",
        useTrailer: true,
        trailerWaitTime: 60,
        trailers: [],
        standByImage: "",
        concessionMenuPdf: "",
        commercialMenuPdf: "",
      };
    },
    cancel_fn() {
      this.$router.go(-1);
    },
    save_fn() {
      this.$refs.cinemaDetailForm.validate(valid => {
        if (valid) {
          let obj = {
            ...this.form,
          };

          obj.trailers = this.$refs.trailerset.returnData();

          if (this.action == "create") {
            createCinema({ cinemaInfo: obj }).then(res => {
              if (res.success) {
                this.countDown(this.$locale("global.createSuccessfully"));
              } else {
                this.$alert(res.message, {
                  showClose: false,
                });
              }
            });
          } else {
            updateCinema({ cinemaInfo: obj }).then(res => {
              if (res.success) {
                this.countDown(this.$locale("global.updateSuccessfully"));
              } else {
                this.$alert(res.message, {
                  showClose: false,
                });
              }
            });
          }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    },
    getRegions_fn() {
      let params = {
        page: 0,
        pageSize: 9999,
      };

      return getRegions(params, false, false);
    },
    getCinemaDetail_fn(id) {
      const that = this;
      const params = {
        id: id
      };

      if (id == "") {
        return new Promise(resolve => {
          resolve({ data: { ...that.form } });
        });
      }
      return getCinemaDetail(params, false, false);
    },
    getCinemaCode_fn() {
      return getCinemaCode({}, false, false);
    },
    getRoleList_fn() {
      const params = {
        page: 0,
        pageSize: 9999,
        status: "active",
      };

      return getRoleList(params, false, false);
    },
    chooseRole(id) {
      this.form = { ...this.form, roleId: id };
    },
    countDown(str) {
      countDownAlert({
        content: str,
        callback: () => {
          this.$router.go(-1);
        }
      });
    },
    getBrandDetail() {
      let brandId = window.localStorage.getItem("brandId");

      return getBrandDetail(brandId);
    },

    plus() {
      this.form.cinemaSetting.gmailList.push({
        gmailUserName: "",
        gmailApiKey: "",
        refreshToken: "",
        accessToken: ""
      });
    },
    minus(idx) {
      if (this.form.cinemaSetting.gmailList.length > 1) {
        this.form.cinemaSetting.gmailList.splice(idx, 1);
      }
    }
  },

  mounted() {
    const that = this;
    let cinemaId = "";
    let { action } = that;

    if (this.$route.params.id) {
      this.breadcrumbTitle = this.$locale("setting.cinema.edit");
      cinemaId = this.$route.params.id;
      action = "edit";
    }

    requestAll([
      that.getRegions_fn(),
      that.getCinemaDetail_fn(cinemaId),
      that.getCinemaCode_fn(),
      that.getRoleList_fn(),
      that.getBrandDetail()
    ]).then(res => {
      that.serialNum = res[4].data.brandCode;
      that.region_arr = res[0].data;
      let { data } = res[1];
      if(data.trailers.length == 0) {
        data.trailers.push({
          type: 1,
          link: "",
          order: 1,
          displayTime: 60,
        });
      }
      this.form = {
        ...data,
        brandCode : res[4].data.brandCode,
        journalCinema1: res[1].data.journalCinema1 || "",
        journalCinema2: res[1].data.journalCinema2 || "",
        journalCinema3: res[1].data.journalCinema3 || "",
        tmsCinemaServer: res[1].data.tmsCinemaServer || "",
        ...res[1].data.cinemaSetting.gmailList === null || !res[1].data.cinemaSetting.gmailList ? {
          cinemaSetting: {
            ...res[1].data.cinemaSetting,
            gmailList: [ {
              gmailUserName: res[1].data.cinemaSetting.gmailUserName || "",
              gmailApiKey: res[1].data.cinemaSetting.gmailApiKey || "",
              refreshToken: "",
              accessToken: ""
            } ]
          }
        } : {}
      };
      this.$refs.trailerset.setTrailers(data.trailers);
      that.allRoles = [ ...res[3].data.data ];
    });

    that.action = action;
  },
};
</script>
